module.exports = __webpack_public_path__ + "img/main.md.b1407fc4.jpg";